import { ExternalLink } from "lucide-react";

import { Badge } from "@/components/ui/badge";
import type { TradeIdeasFilter } from "@/lib/tradeideas/types";

export function FilterCatalogTable({ filters }: { filters: TradeIdeasFilter[] }) {
  return (
    <section className="overflow-hidden rounded-md border border-border">
      <div className="grid grid-cols-[1fr_0.7fr_0.7fr_1.6fr_0.8fr] border-b border-border bg-muted/30 px-3 py-2 text-[11px] font-medium uppercase tracking-wider text-muted-fg">
        <span>Filter</span>
        <span>Type</span>
        <span>Unit</span>
        <span>Formula / Description</span>
        <span>Source</span>
      </div>
      {filters.map((filter) => (
        <div
          key={filter.key}
          className="grid grid-cols-[1fr_0.7fr_0.7fr_1.6fr_0.8fr] items-start gap-3 border-b border-border/60 px-3 py-2 text-sm last:border-b-0"
        >
          <div className="min-w-0">
            <div className="truncate font-medium">
              {filter.display_name || filter.tradeideas_name}
            </div>
            <div className="truncate font-mono text-[11px] text-muted-fg">{filter.key}</div>
            {filter.aliases.length > 0 ? (
              <div className="mt-1 truncate text-[11px] text-muted-fg">
                {filter.aliases.join(", ")}
              </div>
            ) : null}
          </div>
          <Badge variant="outline">{filter.data_type || "string"}</Badge>
          <span className="text-xs text-muted-fg">{filter.unit || "-"}</span>
          <div className="min-w-0 text-xs text-muted-fg">
            <div className="truncate">{filter.formula || filter.description || "-"}</div>
            {filter.docs_url ? (
              <a
                href={filter.docs_url}
                target="_blank"
                rel="noreferrer"
                className="mt-1 inline-flex items-center gap-1 text-accent hover:underline"
              >
                Docs
                <ExternalLink className="size-3" />
              </a>
            ) : null}
          </div>
          <Badge variant={filter.source === "built_in" ? "success" : "secondary"}>
            {filter.source}
          </Badge>
        </div>
      ))}
    </section>
  );
}
